<po-page-default p-title="Cadastro de rubricas" [p-breadcrumb]="breadcrumb">
  <div class="po-row">
    <po-container class="po-lg-12 po-md-12 po-sm-12">
      <div class="po-lg-12 po-mb-2 cabecalho-rubricas">
        <span class="po-font-text-uppercase">
          <span class="an an-list-numbers"></span>
          Rubricas eSocial x Domínio
        </span>
        <po-button
          p-size="small"
          p-kind="secondary"
          p-icon="an an-magnifying-glass"
          p-label="Descobrir rubricas"
          (p-click)="irParaDescobrir()">
        </po-button>
      </div>

      <div class="po-lg-12 po-mb-4 destaque">
        <p class="po-font-text-large po-mb-1">
          Cadastre a correlação da rubrica do eSocial com o evento da Domínio, uma a uma ou pela planilha.
        </p>
        <p>
          <b>
            Se a empresa já tiver essa rubrica, o cadastro avisa e atualiza o evento e a descrição quando mudarem.
          </b>
        </p>
      </div>

      <h4 class="po-lg-12">Cadastro manual</h4>

      <div class="po-row">
        <div class="po-lg-6 po-md-12">
          <app-empresa-combo
            name="codiEmp"
            label="Empresa"
            [(ngModel)]="codiEmp"
            [disabled]="salvando">
          </app-empresa-combo>
        </div>
        <div class="po-lg-6 po-md-12">
          <po-input
            name="rubricaEsocial"
            p-label="Rubrica eSocial"
            p-placeholder="Código da rubrica no eSocial"
            p-required="true"
            p-clean="true"
            [(ngModel)]="rubricaEsocial">
          </po-input>
        </div>
        <div class="po-lg-6 po-md-12">
          <po-number
            name="rubricaDominio"
            p-label="Rubrica Domínio"
            p-help="Evento (i_eventos) na Domínio."
            p-required="true"
            [p-min]="1"
            p-step="1"
            [(ngModel)]="rubricaDominio">
          </po-number>
        </div>
        <div class="po-lg-6 po-md-12">
          <po-input
            name="descricao"
            p-label="Descrição"
            p-placeholder="Opcional"
            [p-maxlength]="100"
            p-clean="true"
            [(ngModel)]="descricao">
          </po-input>
        </div>
      </div>

      <po-button
        class="po-lg-3 po-mt-2"
        p-icon="an an-floppy-disk"
        p-label="Cadastrar rubrica"
        (p-click)="cadastrar()"
        [p-loading]="salvando"
        [p-disabled]="salvando">
      </po-button>

      <div class="po-lg-12 po-mt-3 aviso-cadastrada" *ngIf="cadastro && jaCadastrada(cadastro.status)">
        <p>
          <b>A empresa {{ cadastro.codiEmp }} já tinha a rubrica {{ cadastro.codRubrEsocial }} cadastrada.</b>
        </p>
        <p>{{ cadastro.status }}</p>
      </div>

      <div class="po-lg-12 po-mt-3 destaque" *ngIf="cadastro && !jaCadastrada(cadastro.status)">
        <p><b>{{ cadastro.status }}</b> — empresa {{ cadastro.codiEmp }}, rubrica {{ cadastro.codRubrEsocial }}.</p>
      </div>

      <h4 class="po-lg-12 po-mt-4">Importar planilha</h4>

      <div class="po-lg-12 po-mb-3 destaque">
        <p>
          Colunas: RubricasEsocial, Descrição, RubricaDominio e CodigoDeEmpresa. Linha sem evento da Domínio não é gravada.
        </p>
      </div>

      <div class="po-lg-12">
        <po-upload
          #uploadPlanilha
          [p-restrictions]="planilhaRestrictions"
          p-size="medium"
          [p-drag-drop]="true"
          [p-multiple]="false"
          [p-drag-drop-height]="120"
          [p-url]="urlPlaceholder"
          [p-hide-send-button]="true"
          [p-disabled]="importando"
          p-label="Planilha de rubricas (.xlsx)">
        </po-upload>
      </div>

      <po-button
        class="po-lg-3 po-mt-3"
        p-icon="an an-upload"
        p-label="Importar planilha"
        (p-click)="importarPlanilha()"
        [p-loading]="importando"
        [p-disabled]="importando">
      </po-button>

      <div class="po-lg-12 po-mt-3 aviso-cadastrada" *ngIf="linhasJaCadastradas.length">
        <p><b>Rubricas que a empresa já tinha cadastradas</b></p>
        <ul>
          <li *ngFor="let linha of linhasJaCadastradas">
            Empresa {{ linha.codiEmp }} · {{ linha.codRubrEsocial }}
            <span *ngIf="linha.descricao"> ({{ linha.descricao }})</span>
            — {{ linha.status }}
          </li>
        </ul>
      </div>

      <div class="po-lg-12 po-mt-2" *ngIf="importacao">
        <p>
          {{ importacao.inseridas }} inserida(s), {{ importacao.atualizadas }} atualizada(s),
          {{ importacao.semAlteracao }} sem alteração.
        </p>
        <p *ngFor="let aviso of importacao.avisos"><b>{{ aviso }}</b></p>
        <div class="status-row" *ngFor="let linha of importacao.linhas">
          <div class="step-dot" [ngClass]="classeStatus(linha.status)"></div>
          <div>
            <p class="status-title">
              <b>{{ linha.codRubrEsocial }}</b>
              <span *ngIf="linha.descricao"> — {{ linha.descricao }}</span>
            </p>
            <p class="status-desc">
              Empresa {{ linha.codiEmp }}
              <span *ngIf="linha.iEventosDominio"> · Domínio {{ linha.iEventosDominio }}</span>
              · {{ linha.status }}
            </p>
          </div>
        </div>
      </div>
    </po-container>
  </div>
</po-page-default>
